import axios from 'axios';
import { ElNotification } from 'element-plus';
import { defineComponent, h, ref, type Ref } from 'vue';
import { ElProgress } from 'element-plus';
import { localS } from '@/utils/cache';
import {T} from './index'
// 解析文件名：支持 filename / filename*=UTF-8''
function getFileNameFromDisposition(disposition?: string) {
    if (!disposition) return 'download';
    // filename*=UTF-8''xxx
    const m1 = disposition.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
    if (m1?.[1]) return decodeURIComponent(m1[1].replace(/(^"|"$)/g, '').trim());

    // filename="xxx"
    const m2 = disposition.match(/filename\s*=\s*"?([^"]+)"?/i);
    if (m2?.[1]) return m2[1].trim();

    return 'download';
}


const DownloadProgress = defineComponent({
    name: 'DownloadProgress',
    props: {
        percent: { type: Object as () => Ref<number>, required: true },
        text: { type: String, default: '' }
    },
    setup(props) {
        return () =>
            h('div', { style: 'width: 250px' }, [
                h('div', { style: 'margin-bottom: 8px;padding-right:8px' }, props.text || 'Downloading...'),
                h(ElProgress, {
                    percentage: Math.min(100, Math.max(0, Math.round(props.percent.value))),
                    textInside: true,
                    strokeWidth: 18
                })
            ]);
    }
});
// 转地址栏参数
const toQueryString = (obj: any) => {
    let queryString = '';
    if (obj instanceof FormData) {
        // 如果是 FormData 对象
        for (const arr of obj.entries()) {
            const key: any = arr[0];
            const value: any = arr[1];
            queryString += encodeURIComponent(key) + '=' + encodeURIComponent(value) + '&';
        }
    } else {
        // 如果是普通对象
        for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                queryString += encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]) + '&';
            }
        }
    }
    // 移除最后的 "&" 字符
    return queryString.slice(0, -1);
};
// 获取用户的信息,判断session是否过期
export const getUser = async () => {
    const Api = await import('@/api/user');
    return Api.default.user();
};
// 下载文件（带进度条）
export const downLoadFile = async (url: string, data: any) => {
    const user = await getUser();

    const queryParams = toQueryString(data);
    const fullUrl = queryParams ? `${url}?${queryParams}` : url;

    const percent = ref(0);

    // 进度通知：不自动关闭，下载结束手动关闭
    const notify = ElNotification({
        title: 'Notice',
        message: h(DownloadProgress, { percent, text: T('Tip.downloading') }),
        type: 'info',
        duration: 0,
        showClose: true
    });

    try {
        const res = await axios.get(fullUrl, {
            responseType: 'blob',
            headers: {
                withCredentials: true,
                xsrfCookieName: 'XSRF-TOKEN',
                xsrfHeaderName: 'X-XSRF-TOKEN',
                'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
            },
            onDownloadProgress: (e) => {
                if (e.total && e.total > 0) {
                    percent.value = (e.loaded / e.total) * 100;
                }
            }
        });

        // 进度拉满
        percent.value = 100;

        const disposition = res.headers?.['content-disposition'] as string | undefined;
        const fileName = getFileNameFromDisposition(disposition);

        const blob = res.data as Blob;
        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(objectUrl);

        notify.close();
    } catch (err: any) {
        notify.close();
        ElNotification({
            title: 'Error',
            message: err?.message || 'Download failed',
            type: 'error',
            duration: 3000
        });
        throw err;
    }
};
